export default "__VITE_ASSET__fbd960c5__$_?component__"